module.exports = __webpack_public_path__ + "static/media/image-card-2.c58b3909.png";